import { Box, Typography, Button, Switch } from "@mui/material";
import { setStatus } from "../../api/drivers";
import { useState } from "react";

export default function ProductItemCard({
  product,
  showButton = false,
  onStatusChange,
}: {
  product: any;
  showButton: boolean;
  onStatusChange?: () => void;
}) {
  const [loading, setLoading] = useState(false);

  const checked = product.status_id === 1;

  const handleToggle = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const checked = e.target.checked;

    try {
      setLoading(true);

      let response = await setStatus({
        id: product.id,
        checked: checked ? 1 : 0,
      });

      if (response?.data.status) {
        onStatusChange?.(); 
      }
       
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
      }}
    >
      {/* ---------- IZQUIERDA ---------- */}
      <Box sx={{ display: "flex", gap: 2 }}>
        

        <Box>
          <Typography sx={{ fontSize: 13, fontWeight: 600 }}>
            {product.full_name}
          </Typography>

          <Typography sx={{ fontSize: 12, color: "#666" }}>
            {product.dni}
          </Typography>

          {/* <Typography sx={{ fontSize: 12, color: "#111", mt: 0.5 }}>
            {product.email}
          </Typography> */}
        </Box>
      </Box>

      {/* ---------- DERECHA ---------- */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Switch
          size="small"
          checked={checked}
          onChange={handleToggle}
          disabled={loading}
        />

        {showButton && (
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#111",
              color: "#fff",
              textTransform: "none",
              fontSize: 12,
              px: 2,
              py: 0.3,
              borderRadius: "10px",
              boxShadow: "none",
              "&:hover": {
                backgroundColor: "#222",
              },
            }}
          >
            Atender
          </Button>
        )}
      </Box>
    </Box>
  );
}
